import styled from 'styled-components';

export const ErrorFeedbackContainer = styled.div`
  background: ${({ color }) => color || ''};
  border-radius: 4px;
  padding: 4px 16px;
  display: flex;
  align-items: center;
  color: white;
  margin: 24px;

  i {
    padding-right: 4px;
  }
  p {
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
  }
`;
